import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelDiscountDependency = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Is Margin Dependent on Discounts?";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const renamedTable =
    table && Array.isArray(table.rows)
      ? {
          ...table,
          rows: table.rows.map((row) => {
            if (!row || row.length === 0) return row;
            const metricIndex = row.length >= 3 ? 1 : 0;
            const metric = row[metricIndex];
            const text = String(metric || "");
            let renamed = text;
            if (text === "CM1 (Discounted)") {
              renamed = "Contribution Before Marketing (Discounted)";
            } else if (text === "CM1 (Full-Price)") {
              renamed = "Contribution Before Marketing (Full-Price)";
            } else if (text === "CM2 (Discounted)") {
              renamed = "Contribution After Marketing (Discounted)";
            } else if (text === "CM2 (Full-Price)") {
              renamed = "Contribution After Marketing (Full-Price)";
            }
            if (metricIndex === 1) {
              return [row[0], renamed, ...row.slice(2)];
            }
            return [renamed, ...row.slice(1)];
          }),
        }
      : table;
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Discount sensitivity"
      sections={[
        {
          title: "Discount Exposure",
          table: renamedTable,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelDiscountDependency;
